import React from 'react';
import { getIn } from 'seamless-immutable';
import styled from 'styled-components';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

const AssortedDisclaimer = ({ product, history }) => {
  const name = getIn(product, ['attributes', 0, 'name'], '');
  const value = getIn(product, ['attributes', 0, 'value'], '');
  const isAssorted = name === 'Modelo' && value === 'SORTIDO';
  return (
    isAssorted && (
      <Box>
        <Separator />
        <Text>
          <Bold>produto sortido:</Bold> o modelo e a cor podem variar de acordo com o estoque da loja escolhida.
        </Text>
        <Link onClick={replaceUrlParams(history, '#modal-product-disclaimer', false, { isAssorted })}>saiba mais</Link>
      </Box>
    )
  );
};

const Box = styled.div`
  margin-bottom: 30px;
`;

const Separator = styled.div`
  border-style: solid;
  border-color: #cecccc;
  border-width: 1px 0px 0px;
  margin: 30px 0px 20px 0px;
  opacity: 0.4;
  width: 100%;
`;

const Bold = styled.strong`
  color: ${({ theme }) => theme.grey.dark};
  font-weight: bold;
`;

const Text = styled.p`
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  text-decoration: underline;
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
  &:active {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export default AssortedDisclaimer;
